<template>
    <reconciliation-step-template 
        :nextStep="nextStep" 
        :previousStep="previousStep" 
        @next="goToNextStep"
        @previous="$emit('previous')"
        :loading="loading">
        
        <template slot="content">
        
            <p class="fs-3 semibold mt-4 mb-2">{{ $l10n.__("Suppression des premières lignes de votre document") }}</p>
            <p class="fs-3 gray-80">{{ $l10n.__("Dans certaines banques, les premières lignes du fichier CSV sont vides ou avec des informations qui ne sont pas des transactions (colonnes d’entête par exemple). Afin d’éviter des erreurs de lectures ou des lignes vides, vous pouvez les sélectionner pour les supprimer de l’import. Si vous n’êtes pas concerné, continuez à l’étape suivante.") }}</p>

            <div class="step-container-table border-black" v-loading="loading">
                <table class="table no-border">
                    <tbody>
                        <tr v-for="(line, index) in csv" :key="index" :class="{'bold' : index == 0 }">
                            <td class="br-1">
                                <el-checkbox-group v-model="lineChecked">
                                    <el-checkbox :label="index" @change="checkLine">&nbsp;</el-checkbox>
                                </el-checkbox-group>
                            </td>
                            <td v-for="(column, indexColumn) in line" :key="indexColumn" class="br-1">
                                {{column}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </reconciliation-step-template>
</template>

<script>
    import ImportStepsMixins from './ImportStepsMixins'
    import BankReconciliationImport from 'api/bankreconciliationImport'

    export default {
        mixins: [ImportStepsMixins],
        data(){
            return {
                loading: true,
                lineChecked: []
            }
        },
        created(){
            BankReconciliationImport.getConfig(this.idImport).then(response => {
                this.$emit('update-csv', response.csv)
                this.$emit('update-import-id', this.idImport)
                this.value.config = response.config.length == 0 ? {offset: null} : response.config
                this.value.config.offset = (this.value.config.offset != null) && (this.value.config.offset > 0) ? this.value.config.offset - 1 : null
                this.updateLineChecked()
                this.loading = false
            })
        },
        methods: {
            checkLine(value, e){
                this.lineChecked = []
                if(value || (!value && this.value.config.offset > parseInt(e.target.value)) ){
                    this.value.config.offset = parseInt(e.target.value)
                    this.updateLineChecked()
                } else{
                    this.lineChecked = []
                    this.value.config.offset = null
                }
            },
            updateLineChecked(){
                if(this.value.config != null && this.value.config.offset != null){
                    for(let i=0;i<=this.value.config.offset;i++){
                        this.lineChecked.push(i)
                    }
                }
            },
            goToNextStep(){
                this.loading = true
                let offsetComputed = null
                if(this.value.config.offset != null && this.value.config.offset >= 0){
                    offsetComputed = this.value.config.offset + 1
                }
                BankReconciliationImport.updateConfig(this.idImport, {offset: offsetComputed}).then(response => {
                    this.loading = false
                    this.$emit('next')
                })
            },
        }
    }
</script>

<style scoped>

</style>
